/*
 * A busca do cabeçalho: o menu de busca (search/SearchMenu), em
 * que o próprio campo do cabeçalho é o campo da busca e os resultados abrem
 * num painel colado embaixo dele — no lugar do botão do core que abria o
 * SearchModal.
 */
import Component from 'flarum/common/Component';
import SearchMenu from '../search/SearchMenu';
export default class HeaderSearch extends Component {
  view() {
    return m(SearchMenu, {
      location: "header"
    });
  }
}
flarum.reg.add('ramon-canela', 'forum/shell/HeaderSearch', HeaderSearch);